export enum VisitCardTypeEnum {
    PAQ = 'PAQ',
    ITINERARY = 'ITINERARY',
    PACKING_LIST = 'PACKING_LIST',
    ACTIVITY_CALENDAR = 'ACTIVITY_CALENDAR',
    EXPERIENCES_MENU = 'EXPERIENCES_MENU',
    PROPERTY_MAP = 'PROPERTY_MAP',
}
